import React from 'react';
import { Nav } from 'react-bootstrap';
import { withRouter } from 'react-router';
import {useDispatch} from "react-redux";
import { NavLink } from 'react-router-dom';
import calendar from '../../../../icons/calendar-alt-regular.svg';
import address from '../../../../icons/address-book-regular.svg';
import hotel from '../../../../icons/inquiries-icon.svg';
import invoice from '../../../../icons/file-invoice-dollar-solid.svg';
import styles from './sidebar.module.css';
import {changeInternalRoute} from "../../../../general_redux/actions";

const Side = () => {
  const dispatch=useDispatch();
  const links = [
    { lable: 'Calendar', img: calendar, to: '/view/calendar', fa: 'fa fa-calendar' ,path:'/calendar' },
    { lable: 'Guests', img: address, to: '/view/guest', fa: 'fa fa-address-book',path:'/guest' },
    { lable: 'Reservations', img: hotel, to: '/view/inquiry', fa: 'fa fa-list-alt',path:'/inquiry' },
    { lable: 'Invoices', img: invoice, to: '/view/invoice', fa: 'fa fa-file',path:'/invoice' },
  ];
  return (
    <>
      <Nav className="d-none d-md-none d-lg-block sidebar" activeKey="/view">
        <div className="sidebar-sticky"/>
        {links &&
          links.map((item,index) => (
            <Nav.Item className={`d-flex justify-content-center ${styles.navItem}`} key={`sidebarLink_${index}`}>
              <NavLink
                to={item.to}
                activeClassName={styles.isActive}
                className={`w-100 d-flex flex-column align-items-center ${styles.linkMenu}`}
                onClick={(e)=>dispatch(changeInternalRoute(item.path))}
              >
                {/* <img src={item.img} className={styles.sidebar_img} /> */}
                <i className={`${item.fa} ${styles.icons}`}/>
                <div className={`${styles.sidebar_link} text-center`}>{item.lable}</div>
              </NavLink>
            </Nav.Item>
          ))}
      </Nav>
    </>
  );
};
const Sidebar = withRouter(Side);
export default Sidebar;
